import React from 'react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, Link2 } from "lucide-react";

interface BulkMatchActionBarProps {
    selectedInsurerCount: number;
    selectedContractorCount: number;
    onCreateMatch: () => void;
    onClearSelection: () => void;
}

export function BulkMatchActionBar({
    selectedInsurerCount,
    selectedContractorCount,
    onCreateMatch,
    onClearSelection
}: BulkMatchActionBarProps) {
    const canMatch = selectedInsurerCount > 0 && selectedContractorCount > 0;
    const totalSelected = selectedInsurerCount + selectedContractorCount;

    return (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-4 duration-300">
            <Card className="shadow-2xl border-2 border-primary bg-white dark:bg-slate-900">
                <div className="px-6 py-3 flex items-center gap-4">
                    <div className="flex items-center gap-2 text-sm">
                        <div className="flex items-center gap-1.5">
                            <div className="w-2 h-2 rounded-full bg-slate-500" />
                            <span className="font-semibold">{selectedInsurerCount}</span>
                            <span className="text-muted-foreground">insurer</span>
                        </div>
                        <span className="text-muted-foreground">•</span>
                        <div className="flex items-center gap-1.5">
                            <div className="w-2 h-2 rounded-full bg-blue-500" />
                            <span className="font-semibold">{selectedContractorCount}</span>
                            <span className="text-muted-foreground">contractor</span>
                        </div>
                        <span className="text-muted-foreground ml-2">
                            ({totalSelected} total selected)
                        </span>
                    </div>

                    <div className="h-6 w-px bg-border" />

                    <div className="flex items-center gap-2">
                        <Button 
                            onClick={onCreateMatch} 
                            disabled={!canMatch}
                            size="sm"
                            className="gap-2"
                        >
                            <Link2 className="h-4 w-4" />
                            Create Match
                        </Button>
                        <Button 
                            onClick={onClearSelection} 
                            variant="outline"
                            size="sm"
                            className="gap-2"
                        >
                            <X className="h-4 w-4" />
                            Clear
                        </Button>
                    </div>
                </div>
            </Card>
        </div>
    );
}
